import { Injectable } from '@angular/core';
import { SessionType } from '@gk/gk-modules';
import { map, Observable } from 'rxjs';
import { MainRoutes } from '../../guards/guard.models';
import { PortalConfigGetter } from '../../services/portal-config/portal-config.interface';
import {
  defaultPortalConfig,
  PortalConfig,
} from '../../services/portal-config/portal-config.model';
import { WebPortalService } from '../../services/web-portal/web-portal.service';

@Injectable({
  providedIn: 'root',
})
export class BailiffPortalProjectConfigService implements PortalConfigGetter {
  constructor(private webPortalService: WebPortalService) {}

  getPortalConfig(): Observable<PortalConfig> {
    return this.webPortalService
      .getWebPortalDataByCurrentRoute(MainRoutes.BailiffPortal)
      .pipe(
        map((webPortal) => ({
          ...defaultPortalConfig,
          isPerunAuthenticationAvailable: webPortal.ewidLogging,
          isPzAuthenticationAvailable: webPortal.pzLogging,
          sessionTypes: [SessionType.PerunAuth],
          accessKeys: ['bailiffPortal'],
          portalId: webPortal.portalId,
          redirectCookieEnabled: true,
          urlPatternsToIncludePortalIdInBody: [
            '/komornik/zamowienie/dodaj',
            '/komornik/osoby/search/noresult/raport',
            '/komornik/osoba/hasNotGotRealEstates/raport',
            '/komornik/osoby/wladanie/raport',
            '/komornik/osoba/przedmioty/raport',
          ],
        })),
      );
  }
}
